import { render, staticRenderFns } from "./NotificacoesTabela.vue?vue&type=template&id=779375ae"
import script from "./NotificacoesTabela.vue?vue&type=script&lang=js"
export * from "./NotificacoesTabela.vue?vue&type=script&lang=js"
import style0 from "./NotificacoesTabela.vue?vue&type=style&index=0&id=779375ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports